import { Button, Input, Form } from "antd";

export const AlumnoFields = ({ isRequired }) => {
    return (
        <>
            <Form.Item
                name="RTN"
                label="RTN"
                tooltip="Registro tributario nacional"
                rules={[
                    { required: isRequired, message: "Este campo es requerido" },
                    {
                        validator: (_, value) => {
                            if (!value || value.length === 0) {
                                return Promise.resolve();
                            }
                            if (value.length === 14) {
                                return Promise.resolve();
                            }
                            return Promise.reject(new Error("El RTN debe tener 14 caracteres"));
                        },
                    },]}>
                <Input placeholder="Introduzca el número del RTN" />
            </Form.Item>
            <Form.Item
                name="Sell_to_Customer_Name_2"
                label="Alumno"
                rules={[{ required: isRequired }]}>
                <Input placeholder="Ingrese el nombre del alumno" />
            </Form.Item>
            <Form.Item
                name="Razon_Social"
                label="Razón social"
                rules={[{ required: isRequired }]}>
                <Input placeholder="Ingrese la razón social" />
            </Form.Item>
            {isRequired && <Form.Item
                name="Bill_to_Address"
                label="Dirección de facturación"
                rules={[
                    {
                        required: isRequired,
                        message: "Ingrese una dirección de facturación",
                    },
                ]}
            >
                <Input />
            </Form.Item>}
        </>
    );
}

export const AlumnoForm = (props) => {
    const { handleSubmit, handleCancel, initialData, isRequired } = props;
    const [form] = Form.useForm();

    return (
        <Form
            form={form}
            name="alumno-form"
            onFinish={(values) => {
                handleSubmit({
                    ...initialData,
                    ...values,
                },);
            }}
            layout="vertical"
        >
            <AlumnoFields isRequired={isRequired} />
            <Form.Item>
                <div style={{ display: "flex", gap: "10px" }}>
                    <Button type="primary" htmlType="submit" block>
                        Aceptar
                    </Button>


                    <Button onClick={() => { handleCancel(form) }} block>
                        Cancelar
                    </Button>
                </div>
            </Form.Item>
        </Form>
    );
}